import React, { useState } from 'react';
import { Button, Popup } from 'semantic-ui-react';
import { useAuth } from '../../context/AuthContext';
import { canAccessSimulation } from '../../utils/simulationAccess';
import SimulationSearchModal from './SimulationSearchModal';

export interface FloatingSimulationButtonProps {
  /** Quando true, não aplica posicionamento fixo (uso dentro de um cluster de FABs). */
  embedded?: boolean;
}

const FloatingSimulationButton: React.FC<FloatingSimulationButtonProps> = ({ embedded = false }) => {
  const { user } = useAuth();
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  if (!canAccessSimulation(user?.roles)) {
    return null;
  }

  const shellStyle: React.CSSProperties = embedded
    ? { position: 'relative', zIndex: 1000, display: 'inline-block' }
    : {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
      };

  return (
    <>
      <div style={shellStyle}>
        <Popup
          content="Simular Planos"
          position={embedded ? 'right center' : 'left center'}
          trigger={
            <Button
              circular
              size="large"
              color="blue"
              icon="calculator"
              onClick={() => setIsSearchModalOpen(true)}
              style={{
                width: '60px',
                height: '60px',
                fontSize: '24px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
              }}
              onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.25)';
              }}
              onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
              }}
            />
          }
        />
      </div>

      {/* Search Modal */}
      {isSearchModalOpen && (
        <SimulationSearchModal
          open={isSearchModalOpen}
          onClose={() => setIsSearchModalOpen(false)}
        />
      )}
    </>
  );
};

export default FloatingSimulationButton;

